// IMPORTANT: if googleRecaptcha is enabled again. Enable all useRecaptcha in the project
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import { ErrorProvider } from 'hooks/useError';
import { StoreProvider } from 'hooks/useStore';
import AppRouter from 'Router/Router';
import { isDevEnv } from 'utils/isDevEnv';
import DevTools from './DevTools';
import { AffiliateProvider } from 'hooks/webapi/useAffiliate';
import EventCollectorContextProvider from 'hooks/context/EventCollector/EventCollectorContextProvider';
import { HelmetProvider } from 'react-helmet-async';
import useUserBrowserEventsTracking from 'hooks/useUserBrowserEventsTracking';
import { getIsStageOrProdEnv } from 'utils/getEnv';
import { LEGACY_LOGIN_AuthProvider } from 'hooks/webapi/useLegacyLoginAuth';
import { session } from 'session';
import useEventCollector from 'hooks/context/EventCollector/useEventCollector';
import { clearDatadogRumUser } from 'datadog/rum';

const queryClient = new QueryClient();

/** What else the app forgets when the Session ends */
function SessionCleanup() {
  const { reset } = useEventCollector();

  useEffect(
    () =>
      session.onLogout(() => {
        reset();
        queryClient.clear();
        clearDatadogRumUser();
      }),
    [reset],
  );

  return null;
}

function App() {
  // Only enable user events tracking in stage or production environments
  if (getIsStageOrProdEnv()) {
    // The environment never changes at runtime, so the hook order stays stable
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useUserBrowserEventsTracking();
  }

  return (
    <HelmetProvider context={{}}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
        <StoreProvider>
          <LEGACY_LOGIN_AuthProvider>
            <EventCollectorContextProvider>
              <SessionCleanup />
              {isDevEnv() && <DevTools />}
              <ErrorProvider>
                <AffiliateProvider>
                  {/* <GoogleReCaptchaProvider
                  reCaptchaKey={import.meta.env.VITE_RECAPTCHA_KEY as string}
                > */}
                  <AppRouter />
                  {/* </GoogleReCaptchaProvider> */}
                </AffiliateProvider>
              </ErrorProvider>
            </EventCollectorContextProvider>
          </LEGACY_LOGIN_AuthProvider>
        </StoreProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
